// ─── Enums ────────────────────────────────────────────────────────────────────

export enum ReceiptStatus {
  ACTIVE = "ACTIVE",
  VOID = "VOID"
}

// ─── Core Entity Types ────────────────────────────────────────────────────────

/**
 * Receipt is generated automatically when recordPayment is called.
 * There are no standalone receipt mutations — receipts are read-only.
 */
export interface Receipt {
  receiptId: string;
  paymentId: string;
  invoiceId: string;
  invoiceNumber: string;
  orderId: string;
  orderNumber: string;
  amount: number; // Float in schema
  paymentDate: string;
  reference: string | null;
  paymentMethod: string;
  createdAt: string;
  status: ReceiptStatus;
}

// ─── Input Types ──────────────────────────────────────────────────────────────

export interface GetReceiptByIdInput {
  receiptId: string;
}

export interface GetReceiptByPaymentInput {
  paymentId: string;
}

export interface ListReceiptsByInvoiceInput {
  invoiceId: string;
}

export interface ListReceiptsByOrderInput {
  orderId: string;
}

// ─── API Response Types ───────────────────────────────────────────────────────
// Each key matches the exact GraphQL operation name.

export interface GetReceiptResponse {
  getReceiptById: {
    code: string;
    receipt: Receipt | null;
  };
  getReceiptByPayment: {
    code: string;
    receipt: Receipt | null;
  };
}

export interface ListReceiptsResponse {
  listReceiptsByInvoice: {
    code: string;
    receipts: Receipt[];
  };
  listReceiptsByOrder: {
    code: string;
    receipts: Receipt[];
  };
  listReceiptsByStore: {
    code: string;
    receipts: Receipt[];
  };
  listReceiptsByCompany: {
    code: string;
    receipts: Receipt[];
  };
}
